<price-calculator-component
  [componentType]=ComponentTypeEnum.MULTIPLE
  [productConfig]="productConfig()"
  [language]="language()"
  [portalBaseUrl]="portalBaseUrl()"
  [promosUrl]="promosUrl()"
></price-calculator-component>

